/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'fabric.emoji.add.custom.emoji.label': '添加您自己的表情符号',
  'fabric.emoji.add.label': '添加表情符号',
  'fabric.emoji.cancel.label': '取消',
  'fabric.emoji.categories.label': '选择表情类别',
  'fabric.emoji.categories.search.results': '搜索结果',
  'fabric.emoji.category.activity': '活动',
  'fabric.emoji.category.all.uploads': '所有上传',
  'fabric.emoji.category.flags': '标记',
  'fabric.emoji.category.foods': '食物和饮品',
  'fabric.emoji.category.frequent': '频率',
  'fabric.emoji.category.nature': '性质',
  'fabric.emoji.category.objects': '对象',
  'fabric.emoji.category.people': '人员',
  'fabric.emoji.category.places': '旅行和地点',
  'fabric.emoji.category.productivity': '生产力',
  'fabric.emoji.category.symbols': '符号',
  'fabric.emoji.category.user.uploads': '您的上传',
  'fabric.emoji.choose.file.screenReaderDescription': '为表情选择一个文件。JPG、PNG 或 GIF。文件大小不得超过 1 MB',
  'fabric.emoji.choose.file.title': '选择文件',
  'fabric.emoji.delete.description': '此表情符号的所有现有实例将替换为{emojiShortName}',
  'fabric.emoji.delete.label': '删除',
  'fabric.emoji.delete.screenreader.tooltip': '要删除 {shortName} 表情，请按 Backspace 键',
  'fabric.emoji.delete.title': '删除表情符号',
  'fabric.emoji.delete.tooltip': '删除',
  'fabric.emoji.emojipicker.emoi.roledescription': '表情按钮',
  'fabric.emoji.emojipicker.error': '错误！',
  'fabric.emoji.error.delete.failed': '删除失败',
  'fabric.emoji.error.image.too.big': '选择的图像超过 1 MB',
  'fabric.emoji.error.invalid.image': '选择的图像无效',
  'fabric.emoji.error.upload.failed': '上传失败',
  'fabric.emoji.error.upload.timeout': '上传已超时',
  'fabric.emoji.image.requirements': 'JPG、PNG 或 GIF 最大为 1 MB。',
  'fabric.emoji.name.ariaLabel': '为新表情符号输入名称',
  'fabric.emoji.picker': '表情选择器',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {搜索结果} other {表情}}',
  'fabric.emoji.pickerlist.tabpanel': '表情操作和列表面板',
  'fabric.emoji.placeholder': '例如，您好',
  'fabric.emoji.preview': '您的新表情符号{emoji}看起来很棒',
  'fabric.emoji.preview.title': '预览',
  'fabric.emoji.retry.label': '重试',
  'fabric.emoji.search.label': '表情名称',
  'fabric.emoji.search.placeholder': '搜索',
  'fabric.emoji.search.status': '查看所有表情',
  'fabric.emoji.select.skin.list.ariaLabel': '肤色选择器',
  'fabric.emoji.select.skin.tone.ariaLabel': '选择您的肤色，已选：{selectedTone}',
};
